<template>
  <div class="shop">
    <!-- Hero -->
    <section class="hero">
      <div class="hero-content">
        <h1>造坊处</h1>
        <p>为您的爱宠挑选纪念好物</p>
      </div>
    </section>

    <!-- 产品分类 -->
    <section class="categories">
      <div class="container">
        <div class="categories-list">
          <button
            v-for="cat in categories"
            :key="cat.id"
            :class="['category-btn', { active: currentCategory === cat.id }]"
            @click="currentCategory = cat.id"
          >
            {{ cat.name }}
          </button>
        </div>
      </div>
    </section>

    <!-- 产品列表 -->
    <section class="products">
      <div class="container">
        <div class="products-grid">
          <div class="product-card" v-for="(product, index) in products" :key="index">
            <div class="product-image">
              <img src="/communication_box.jpg" alt="宠物星球骨灰盒" class="product-img">
            </div>
            <div class="product-info">
              <h3>{{ product.name }}</h3>
              <p>{{ product.description }}</p>
              <div class="product-price">¥{{ product.price }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 定制服务 -->
    <section class="custom-service">
      <div class="container">
        <div class="custom-content">
          <div class="custom-text">
            <h2>定制服务</h2>
            <p>我们提供个性化定制服务，为您打造独一无二的纪念品</p>
            <ul class="custom-features">
              <li>专属刻字服务</li>
              <li>照片定制</li>
              <li>个性化设计</li>
            </ul>
          </div>
          <div class="custom-image">
            <div class="image-placeholder">🎨</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Shop',
  data() {
    return {
      currentCategory: 'box',
      categories: [
        { id: 'box', name: '骨灰盒' }
      ],
      products: [
        {
          name: '宠物星球骨灰盒',
          description: '永恒守护，珍藏回忆，让爱永远延续',
          price: 1280,
          emoji: '🌟'
        }
      ]
    }
  }
}
</script>

<style scoped>
.shop {
  padding-top: 70px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero - 星空渐变 */
.hero {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  padding: 120px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 70%, rgba(123, 104, 238, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 30%, rgba(230, 168, 215, 0.1) 0%, transparent 40%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
  border-radius: 50%;
  box-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero h1 {
  font-size: 3rem;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 700;
  text-shadow: 0 0 40px rgba(123, 104, 238, 0.5);
}

.hero p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.85);
}

/* Categories */
.categories {
  padding: 40px 0;
  background: #fff;
  border-bottom: 1px solid rgba(123, 104, 238, 0.1);
}

.categories-list {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.category-btn {
  padding: 12px 30px;
  border: none;
  background: #f8f7ff;
  color: #666;
  border-radius: 25px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.category-btn:hover,
.category-btn.active {
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(123, 104, 238, 0.3);
}

/* Products */
.products {
  padding: 80px 0;
  background: linear-gradient(180deg, #f8f7ff 0%, #f0edff 100%);
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.product-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(123, 104, 238, 0.1);
  box-shadow: 0 4px 20px rgba(48, 43, 99, 0.05);
}

.product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(123, 104, 238, 0.15);
}

.product-image {
  height: 280px;
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 20px;
}

.product-info {
  padding: 30px;
}

.product-info h3 {
  font-size: 1.3rem;
  color: #302b63;
  margin-bottom: 10px;
  font-weight: 600;
}

.product-info p {
  color: #888;
  margin-bottom: 15px;
  font-size: 0.95rem;
}

.product-price {
  font-size: 1.5rem;
  color: #7b68ee;
  font-weight: 700;
}

/* Custom Service */
.custom-service {
  padding: 100px 0;
  background: #fff;
}

.custom-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.custom-text h2 {
  font-size: 2.2rem;
  color: #302b63;
  margin-bottom: 20px;
  font-weight: 600;
}

.custom-text > p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 30px;
  font-size: 1.05rem;
}

.custom-features {
  list-style: none;
  margin-bottom: 30px;
}

.custom-features li {
  padding: 12px 0;
  color: #666;
  font-size: 1.05rem;
  position: relative;
  padding-left: 30px;
}

.custom-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #7b68ee;
  font-weight: bold;
}

.btn-primary {
  padding: 15px 40px;
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  color: #fff;
  border: none;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(123, 104, 238, 0.4);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(123, 104, 238, 0.5);
}

.custom-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-placeholder {
  width: 350px;
  height: 350px;
  background: linear-gradient(135deg, #f8f7ff 0%, #f0edff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8rem;
  border: 2px solid rgba(123, 104, 238, 0.1);
}

@media (max-width: 968px) {
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .custom-content {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .custom-image {
    order: -1;
  }

  .image-placeholder {
    width: 250px;
    height: 250px;
    font-size: 5rem;
  }
}

@media (max-width: 600px) {
  .hero h1 {
    font-size: 2.2rem;
  }

  .products-grid {
    grid-template-columns: 1fr;
  }

  .custom-text h2 {
    font-size: 1.8rem;
  }
}
</style>
